import type { ReturnLabel, ReturnRequest } from '../types';
import { apiClient } from './client';

export const returnsAPI = {
  create: async (form: FormData) => {
    const res = await apiClient.post<ReturnRequest>('orders/me/returns/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },
  list: async () => {
    const res = await apiClient.get<{ results: ReturnRequest[] } | ReturnRequest[]>('orders/me/returns/');
    return Array.isArray(res.data) ? res.data : res.data.results;
  },
  detail: async (id: string) => {
    const res = await apiClient.get<ReturnRequest>(`orders/me/returns/${id}/`);
    return res.data;
  },
  cancel: async (id: string) => {
    const res = await apiClient.post<ReturnRequest>(`orders/me/returns/${id}/cancel/`);
    return res.data;
  },
  label: async (id: string) => {
    const res = await apiClient.get<ReturnLabel>(`orders/me/returns/${id}/label/`);
    return res.data;
  },
};